// src/layout/ProtectedRoute.js
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { LoadingSpinner } from './index';
import { api } from '../services/api';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [checkingMaintenance, setCheckingMaintenance] = useState(true);

  useEffect(() => {
    const checkMaintenanceMode = async () => {
      try {
        const response = await api.getMaintenanceStatus();
        if (response.status === 'success' && response.maintenance) {
          setMaintenanceMode(response.maintenance.enabled);
        }
      } catch (error) {
        console.error('Error checking maintenance mode:', error);
      } finally {
        setCheckingMaintenance(false);
      }
    };

    if (isAuthenticated) {
      checkMaintenanceMode();
    } else {
      setCheckingMaintenance(false);
    }
  }, [isAuthenticated]);

  if (isLoading || checkingMaintenance) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // If maintenance mode is active and user is not an admin, redirect to maintenance page
  if (maintenanceMode && (!user || user.role !== 'admin')) {
    return <Navigate to="/maintenance-page" replace />;
  }

  return children;
};

export default ProtectedRoute;
